export const statusOptions = [
  {
    name: "Single",
    value: "single"
  },
  {
    name: "Married Filing Jointly",
    value: "married"
  }
];